module.exports = __webpack_public_path__ + "img/sf.6f24dd6d.png";